import { ItemInfoDialog } from '@colonist/clientforge';
import { getLobbyImagePath } from '../ui_utils/Utils.ts';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderItemInfoDialog = mountDialogUIReactComponent(ItemInfoDialog);
export function showItemInfoDialog(title, image, description) {
    renderItemInfoDialog({
        title: title,
        imageUrl: getLobbyImagePath(image),
        description: description
    });
}
